Bingo.DateTimePicker = {};
Bingo.DateTimePicker.Position = {};
Bingo.DateTimePicker.Position.TopRight = 'top-right';
Bingo.DateTimePicker.Position.BottomRight = 'bottom-right';

Bingo.DateTimePicker.init = function (selector, language, position) {
    const positionString = (position) || Bingo.DateTimePicker.Position.TopRight;

    $(`${selector} input.date, ${selector} input.datetime-local`).each((i, el) => {
        if (!language) {
            language = 'en';
        }
        el = $(el);
        el.get(0).type = 'text';
        el.datetimepicker({
            language,
            startDate: el.attr('min'),
            endDate: el.attr('max'),
            weekStart: 1,
            minView: el.is('.date') ? 'month' : 'hour',
            format: el.is('.date') ? 'dd.mm.yyyy' : 'dd.mm.yyyy hh:ii', // for seconds support use 'd. m. yyyy - hh:ii:ss'
            autoclose: true,
            pickerPosition: positionString,
        })
            .on('show', (event) => {
                Nette.validateControl(event.target);
                $(event.target).parents('.js-textField').addClass('-errorPrevented -labelUp');
            })
            .on('hide', (event) => {
                $(event.target).parents('.js-textField').removeClass('-errorPrevented');
            })
            .on('changeDate', (event) => {
                $(event.target).focus();
                Nette.validateControl(event.target);
            });
        if (el.attr('value')) {
            el.datetimepicker('setValue');
        }

        // Fix not scrolling popup if inside bootstrap modal
        el.closest('.modal').on('scroll', () => {
            const data = el.data('datetimepicker');
            if (data) {
                data.place();
            }
        });

        // Open plugin on icon click
        const iconWrapper = el.closest('.js-textField').find('.js-textField__sideArea');
        iconWrapper.addClass('cursor-pointer');
        iconWrapper.click(() => {
            const data = el.data('datetimepicker');
            if (data) {
                data.show();
            }
        });
    });
};
